import { Loading } from '@library/components/Loading';
import { NoResults } from '@library/components/NoResults';
import { PageTitle } from '@library/components/PageTitle';
import { useGetMissionByIdQuery } from '@bo-services/promotionsApi';
import { useParams } from 'react-router-dom';

export const ViewMission = () => {
  const { challengeId = '' } = useParams<{
    challengeId: string;
  }>();
  const { data: mission, isLoading: isMissionLoading } = useGetMissionByIdQuery(
    { challenge_id: challengeId },
    { skip: !challengeId }
  );

  if (isMissionLoading) {
    return <Loading loadingMessage="Loading Missions" />;
  }

  if (!mission) {
    return <NoResults className="m-0" label="Mission Not Found" />;
  }

  return (
    <div className="flex w-auto flex-col gap-4 px-6 pb-2 pt-3">
      <div className="flex flex-col justify-between gap-y-2">
        <PageTitle title={mission.name} />
        <p className="text-soClean-160 text-sm">{mission.description}</p>
        <pre className="text-atlien-100 w-1/2 text-wrap text-xs">
          {JSON.stringify(mission, null, 2)}
        </pre>
      </div>
    </div>
  );
};
